import {Action} from 'redux';

import ModalTypes from '../../enums/app/modalTypes';
import FWU_TARGET_TYPES from '../../enums/iot/fwuTargetTypes';
import {IModalActionProps, IModalState} from '../types/modal';

enum ActionTypes {
    SHOW_MODAL = 'app/modal/SHOW_MODAL',
    HIDE_MODAL = 'app/modal/HIDE_MODAL',
    ADD_MODAL_TO_RENDERED_MODALS = 'app/modal/ADD_MODAL_TO_RENDERED_MODALS',
    REMOVE_MODAL_FROM_RENDERED_MODALS = 'app/modal/REMOVE_MODAL_FROM_RENDERED_MODALS',
}
interface IModalAction extends Action {
    type: ActionTypes;
    payload: IModalActionProps | string;
}

const initialState: IModalState = {
    globalModals: [],
    renderedModals: [],
};

export default (state = initialState, action: IModalAction): IModalState => {
    switch (action.type) {
        case ActionTypes.SHOW_MODAL: {
            const {modalType, modalProps} = action.payload as IModalActionProps;

            if (state.globalModals.some((modal) => modal.modalType === modalType)) {
                return state;
            } else {
                return {
                    ...state,
                    globalModals: [
                        ...state.globalModals,
                        {
                            modalType,
                            modalProps,
                        },
                    ],
                };
            }
        }
        case ActionTypes.HIDE_MODAL: {
            const {modalType} = action.payload as IModalActionProps;

            return {...state, globalModals: state.globalModals.filter((modal) => modal.modalType !== modalType)};
        }
        case ActionTypes.ADD_MODAL_TO_RENDERED_MODALS: {
            const id = action.payload as string;

            if (state.renderedModals.some((modalId) => modalId === id)) {
                return state;
            } else {
                return {
                    ...state,
                    renderedModals: [...state.renderedModals, id],
                };
            }
        }
        case ActionTypes.REMOVE_MODAL_FROM_RENDERED_MODALS: {
            const id = action.payload as string;

            return {...state, renderedModals: state.renderedModals.filter((modalId) => modalId !== id)};
        }
        default:
            return state;
    }
};

export const showHidReconnectModalAction = (modalProps?: unknown): IModalAction =>
    showModalAction({modalType: ModalTypes.HID_RECONNECT, modalProps});

interface IDeviceIsInSblModalProps {
    isInitialFlow?: boolean;
    fwu_target: FWU_TARGET_TYPES;
}

export const showDeviceIsInSblModalAction = (modalProps: IDeviceIsInSblModalProps): IModalAction =>
    showModalAction({modalType: ModalTypes.DEVICE_IS_IN_SBL, modalProps});

export const showReconnectDeviceGuideModalAction = (modalProps?: unknown): IModalAction =>
    showModalAction({modalType: ModalTypes.RECONNECT_DEVICE_GUIDE, modalProps});

export const showFWUAdditionalStepsGuidelAction = (modalProps?: unknown): IModalAction =>
    showModalAction({modalType: ModalTypes.FWU_ADDITIONAL_STEPS_GUIDE, modalProps});

export const showFWULedCheckAction = (modalProps?: unknown): IModalAction =>
    showModalAction({modalType: ModalTypes.FWU_LED_CHECK, modalProps});

export const showFWUErrorModalAction = (modalProps?: unknown): IModalAction =>
    showModalAction({modalType: ModalTypes.FWU_ERROR, modalProps});

export const showUsbRequiredModalAction = (modalProps?: unknown): IModalAction =>
    showModalAction({modalType: ModalTypes.USB_REQUIRED, modalProps});

export const showModalAction = ({modalType, modalProps}: IModalActionProps): IModalAction => ({
    type: ActionTypes.SHOW_MODAL,
    payload: {modalType, modalProps},
});

export const hideModalAction = (modalType: ModalTypes): IModalAction => ({
    type: ActionTypes.HIDE_MODAL,
    payload: {modalType},
});

export const addModalToRenderedModals = (id: string): IModalAction => ({
    type: ActionTypes.ADD_MODAL_TO_RENDERED_MODALS,
    payload: id,
});

export const removeModalFromRenderedModals = (id: string): IModalAction => ({
    type: ActionTypes.REMOVE_MODAL_FROM_RENDERED_MODALS,
    payload: id,
});
